import React from 'react';

export default props => (
  <svg {...props} viewBox="0 0 300 300">
    <path
      d="M94.2,272c113.2,0,175.2-93.9,175.2-175.2c0-2.6,0-5.3-0.1-7.9c12-8.6,22.4-19.6,30.7-31.9c-11,4.9-22.9,8.2-35.4,9.7
      c12.7-7.6,22.4-19.7,27.1-34.1c-11.9,7.1-25.1,12.1-39.1,14.9c-11.3-12-27.3-19.4-44.9-19.4c-34,0-61.6,27.6-61.6,61.6
      c0,4.8,0.6,9.5,1.6,14c-51.1-2.5-96.5-27.1-126.9-64.3c-5.3,9.1-8.3,19.7-8.3,31c0,21.4,10.9,40.2,27.4,51.3
      c-10.1-0.4-19.6-3.1-27.9-7.7c0,0.2,0,0.5,0,0.8c0,29.8,21.2,54.7,49.3,60.4c-5.2,1.4-10.6,2.2-16.2,2.2c-4,0-7.8-0.4-11.5-1.1
      c7.8,24.5,30.6,42.3,57.5,42.7c-21.1,16.6-47.7,26.4-76.5,26.4c-4.9,0-9.8-0.2-14.6-0.8C27.1,261.8,59.5,272,94.2,272"
    />
  </svg>
);
